module.exports = __webpack_public_path__ + "img/logo-oak-ridge-bw.4ae58f89.png";